interface HeroSectionProps {
  onConsultClick: () => void;
}

const HeroSection = ({ onConsultClick }: HeroSectionProps) => {
  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-white py-20 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/02acc5c557e983aead1bf197f3478f7c.jpg')`
        }}
      ></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="lg:w-1/2 lg:pr-12">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              業務は、<br />
              <span className="text-blue-600">自動で</span>まわる<br />
              時代へ。
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              業務工数を最大90％削減。Google Apps Script・Excel VBA・AI・各種ツールを活用した業務効率化支援で、これまで複数の企業・事業者様の業務改善を実現しています。
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={onConsultClick}
                className="bg-red-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-red-600 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                無料で相談してみる
              </button>
            </div>
          </div>
          
          <div className="lg:w-1/2 lg:pl-12">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/f944b6b09380cffeaef8984d28dd405e/7a4e69ab12e012e584b23027fac3c7d0.png"
                alt="業務自動化を行うビジネスパーソン"
                className="w-full h-auto rounded-lg shadow-2xl object-cover"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-lg shadow-xl">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">継続率</p>
                    <p className="text-2xl font-bold text-green-600">95%以上</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
